<template>
  <VDialogV3
    id="transport-zone-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localTransportZone"
    :context-menu="TransportZonesService.contextMenu"
    :submit-method="submit"
  >
   <section>
     <VInput
       v-model="localTransportZone.name"
       label="Наименование зоны"
       layout="vertical"
       required
       placeholder="Введите зону"
     />
   </section>
  </VDialogV3>
</template>

<script lang="ts">

import TransportZone from '@/domains/TransportZones/TransportZone';
import TransportZonesService from '@/domains/TransportZones/TransportZonesService';

export default defineComponent({
  name: 'TransportZoneCard',

  props: {
    /** Готовый объект зоны — передаётся из реестра / меню */
    transportZone: {
      type: TransportZone,
      default: null,
    },
    /** ID зоны — передаётся из роутера, карточка сама загружает объект */
    id: {
      type: Number,
      default: null,
    },
  },

  setup() {
    return {
      TransportZonesService,
    };
  },

  data() {
    return {
      localTransportZone: null as TransportZone | null,
    };
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localTransportZone = await TransportZonesService.get(this.id);
      } else if (this.transportZone instanceof TransportZone) {
        this.localTransportZone = this.$core.utils.cloneDeep(this.transportZone);
      } else {
        this.localTransportZone = TransportZone.fromNew();
      }
    },

    async submit(): Promise<boolean> {
      if (this.localTransportZone.isExisting === true) {
        return await TransportZonesService.update(this.localTransportZone);
      } else {
        return await TransportZonesService.add(this.localTransportZone);
      }
    },
  },
});
</script>